import { AfterViewInit, Component } from '@angular/core';

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet>'
})
export class RootComponent implements AfterViewInit {

    ngAfterViewInit(): void {
        App.init();
        App.initComponents();
    }
}
